import React from "react";
import { HiOutlineCheck } from "react-icons/hi2";
import "./FlightBuildStepper.css";

const STEPS = [
  { id: "outbound", label: "הלוך", num: 1 },
  { id: "inbound", label: "חזור", num: 2 },
  { id: "summary", label: "סיכום", num: 3 },
];

/**
 * Stepper RTL: מימין לשמאל — שלב 1 הלוך מימין (ראשון חזותית ב־RTL).
 */
export default function FlightBuildStepper({
  activePhase,
  hasOutbound,
  hasInbound,
  onStepPress,
}) {
  const statusFor = (id) => {
    if (id === "outbound") {
      if (activePhase === "outbound") return "active";
      if (hasOutbound) return "done";
      return "upcoming";
    }
    if (id === "inbound") {
      if (!hasOutbound) return "locked";
      if (activePhase === "inbound") return "active";
      if (hasInbound) return "done";
      return "upcoming";
    }
    if (id === "summary") {
      if (!hasOutbound || !hasInbound) return "locked";
      if (activePhase === "summary") return "active";
      return "upcoming";
    }
    return "upcoming";
  };

  return (
    <nav
      className="fsc-stepper"
      aria-label="שלבי הרכבת מסלול"
      dir="rtl"
    >
      <ol className="fsc-stepper__track">
        {STEPS.map((step, idx) => {
          const status = statusFor(step.id);
          const clickable =
            step.id === "outbound" ||
            (step.id === "inbound" && hasOutbound) ||
            (step.id === "summary" && hasOutbound && hasInbound);
          const isLast = idx === STEPS.length - 1;
          return (
            <li key={step.id} className="fsc-stepper__item">
              <button
                type="button"
                className={`fsc-stepper__btn fsc-stepper__btn--${status}`}
                onClick={() => onStepPress?.(step.id)}
                disabled={!clickable}
                aria-current={status === "active" ? "step" : undefined}
              >
                <span className="fsc-stepper__bubble" aria-hidden>
                  {status === "done" ? (
                    <HiOutlineCheck strokeWidth={2.5} />
                  ) : (
                    <span className="fsc-stepper__num">{step.num}</span>
                  )}
                </span>
                <span className="fsc-stepper__label">{step.label}</span>
              </button>
              {!isLast ? (
                <span
                  className={`fsc-stepper__connector fsc-stepper__connector--${(idx === 0 && hasOutbound) || (idx === 1 && hasInbound) ? "progress" : "muted"}`}
                  aria-hidden
                />
              ) : null}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
